import { useEffect, useState } from 'react';
import { config } from '../utils/config';

export const useUserStatus = () => {
  const [token, setToken] = useState('');
  const [loginState, setLoginState] = useState(false);
  useEffect(() => {
    setToken(config.token());
  }, []);
  useEffect(() => {
    checkLogin();
  }, [token]);
  const checkLogin = () => {
    if (!!config.token()) {
      setLoginState(true);
      return true;
    } else {
      setLoginState(false);
      return false;
    }
  };
  const isLogin = () => {
    return checkLogin();
  };
  return { token, isLogin, loginState };
};
